import * as React from 'react';
import { IPropsBasic } from 'kts-scaffold-framework/modules';
import { Card, Button, Tabs, Icon } from 'antd';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import TableList from './TableList';
const css = require('./index.scss');
const TabPane = Tabs.TabPane;


/** Props接口 */
interface IProps extends IPropsBasic {

}
export default class UIComponents extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            key: '1',
            fresh1: '',
            addModal: false,
        };
    }
    onRefresh = () => {
        if (this.state.key === '1') {
            this.setState({
                fresh1: JSString.randomABC(10)
            });
        }

    }
    callback = (key) => {
        this.setState({
            key
        });
    }
    render() {
        const operations = (
            <div>
                <Button icon="sync" className="" onClick={this.onRefresh}></Button>
            </div>
        );
        const { fresh1 } = this.state;
        return (
            <Card
               
            >
                <Tabs
                    defaultActiveKey="1"
                    tabBarExtraContent={operations}
                >
                    <TabPane tab="进项发票管理" key="1">
                        <TableList refresh={fresh1} />
                    </TabPane>
                </Tabs>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceManage/UI.Components.tsx